export const environment = {
    production: true,
    environmentName: "Testing",
    apiUrl: 'http://api-test.encuentropilka.com/v2'
  };
